import { render } from "./HomeView.vue?vue&type=template&id=1a626634"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=1a626634&lang=css"

import exportComponent from "C:\\Users\\AloneX\\taipeitest\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__